module.exports = __webpack_public_path__ + "mini-about.jpg?3ad66773177f5202efe524d2f8045244";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mini-about.jpg
// module id = 208
// module chunks = 0